import React, { createContext, useContext, useState, useEffect } from "react";

import { initializeFirebase, FirebaseClient } from "../src/modules/firebase/initializeFirebase";

export const FirebaseContext = createContext<FirebaseClient | undefined>(undefined);
export const useFirebase = () => useContext(FirebaseContext);

const FirebaseProvider: React.FC = ({ children }) => {
  const [firebase, setFirebase] = useState<FirebaseClient>();

  useEffect(() => {
    initializeFirebase().then(firebaseClient => setFirebase(firebaseClient));
  }, []);

  return <FirebaseContext.Provider value={firebase}>{children}</FirebaseContext.Provider>;
};

export { FirebaseProvider };
